import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { newDocumentoSelector } from "features/Crear/redux/selectors/newDocumentoSelectors"
import ArticuloService from "features/Inventario/services/ArticuloService"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { nanoid } from "nanoid"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { addConcepto, recalculate } from "../../redux/slices/newDocumentoSlice"
import "./index.scss"

const SearchArticulosComponent = ({ initialEmpresa }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [conceptoSearch, setConceptoSearch] = useState("")
  const [articulos, setArticulos] = useState([])
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes } = useTaxes()
  const taxesFormatted = taxes.map((impuesto) => ({
    // @ts-expect-error TS(2698): Spread types may only be created from object types...
    ...impuesto,
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
    label: `${impuesto.nombre}`,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    value: impuesto.id,
    // @ts-expect-error TS(2339): Property 'valor' does not exist on type 'never'.
    fieldValue: impuesto.valor,
  }))
  const { isLibrado } = useSelector(newDocumentoSelector)
  const dispatch = useDispatch()

  const handleSearchConcepto = (e: $TSMigrationFixMe) => {
    const concepto = e.target.value
    setConceptoSearch(e.target.value)

    if (isLibrado) {
      ArticuloService.getByNif({
        concepto,
        NIF: initialEmpresa?.cif,
        maxResultCount: 5,
      }).then((res) => {
        setArticulos(res.data.items)
      })
    } else {
      ArticuloService.getByFiltersConcepto({
        concepto,
        maxResultCount: 5,
      }).then((res) => {
        setArticulos(res.data.items)
      })
    }
  }

  const handleAddConcepto = (item: $TSMigrationFixMe) => {
    const tipoDocumento = isLibrado ? 0 : 1
    const filteredIVA = taxesFormatted.filter(
      ({ esActivo, grupoImpuesto: { tipoGrupoImpuesto }, tipo }) =>
        tipoGrupoImpuesto === 0 && esActivo && tipo === tipoDocumento
    )
    const taxe =
      filteredIVA.find((entry) => entry.valor === 21) || filteredIVA[0]
    const concepto = {
      id: nanoid(),
      concepto: item?.concepto || conceptoSearch,
      cantidad: 1,
      precioVenta: item?.precioVenta || 0,
      impuestoArticuloTipoId: taxe?.id,
      impuestoArticuloPorcentaje: taxe?.valor,
    }
    setConceptoSearch("")
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(addConcepto(concepto))
    dispatch(recalculate())
  }

  return (
    <div className='relative justify-start w-100 d-flex'>
      <FontAwesomeIcon
        icon={["fal", "magnifying-glass"]}
        className='search-icon'
      />
      <input
        // @ts-expect-error TS(2322): Type 'DefaultTFuncReturn' is not assignable to typ...
        placeholder={t("crear.facturaRec.addConceptLabel")}
        value={conceptoSearch}
        onChange={(e) => handleSearchConcepto(e)}
        className='ml-2 border-none w-50'
        onKeyUp={(e) => {
          // @ts-expect-error TS(2339): Property 'code' does not exist on type 'KeyboardEv...
          if (e.code === "Enter") handleAddConcepto()
        }}
      />

      {conceptoSearch.length > 0 && (
        <div className='absolute mb-5 bg-white shadow-sm w-50 top-5 z-99'>
          <div className='w-full'>
            {articulos.map((item) => (
              <div
                // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
                key={item.id}
                className='items-center justify-start px-4 py-1 truncate hover-element-select d-flex'
                onClick={() => handleAddConcepto(item)}
              >
                {/* @ts-expect-error TS(2339): Property 'concepto' does not exist on type 'never'... */}
                <span>{item.concepto}</span>
              </div>
            ))}
          </div>

          <div
            onClick={handleAddConcepto}
            className='items-center justify-start px-4 py-1 border-t-1 font-500 d-flex hover-element-select'
          >
            <span className='relative text-gedesco'>
              <FontAwesomeIcon
                icon={["fal", "plus"]}
                className='search-icon'
              />
              <span className='mt-1 translate-y-1'>
                {t("crear.facturaRec.addConLabel")}
              </span>{" "}
              <span className='ml-1 text-black translate-y-1'>
                {conceptoSearch}
              </span>
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchArticulosComponent
